const deTranslation = {
  goToSenecaLearning: "Gehen Sie zu Seneca Learning 📚",
  continueWithProvider: "Fahren Sie mit {{provider}} fort",
  redirectBackToTheApp: "Zurück zur App umleiten",
};

export default deTranslation;
